import { Form, FormProps, Radio } from "antd";
import { useEffect } from "react";
import { updateAnyStatusAsync } from "../../../../store/features/anyStatus/anyStatus.Api";
import { useAppDispatch, useAppSelector } from "../../../../store/store";
import { ModalType } from "../../../../types";
import { AnyStatusData } from "../../../../types/status/status";
import FormModal from "../../../ui/FormModal";
import { singleCampaignDataAsync } from "../../../../store/features/EventManage/Campaigns/CampaignApi";

type Props = {
  open: ModalType;
  handleClose: () => void;
};

const eventTypeData = ["event", "webinar", "campaign"]; // Correct values for event_type
const trainingMaterialStatus = [
  "Pending",
  "Published",
  "Cancel",
  "Completed",
  "Draft",
]; // Correct values for status

export default function UpdateAnyStatusCampaign({ open, handleClose }: Props) {
  const [form] = Form.useForm();
  const dispatch = useAppDispatch();
  const { manageLoading } = useAppSelector((state) => state.updateAnyStatus);

  const anyStatusUpdateData = open?.data as AnyStatusData;

  const { singleCampaignData } = useAppSelector((state) => state.campaigns);

  const onFinish: FormProps<any>["onFinish"] = (values) => {
    if (open?.type === "EDIT" && anyStatusUpdateData?.id) {
      dispatch(
        updateAnyStatusAsync({
          data: {
            ...values,
            id: anyStatusUpdateData?.id, // Ensure `id` is included
          },
          others: {
            reRender: handleClose,
            id: anyStatusUpdateData?.id,
          },
        })
      );
    }
  };

  useEffect(() => {
    dispatch(
      singleCampaignDataAsync({
        params: {
          id: anyStatusUpdateData?.id,
        },
      })
    );
  }, [dispatch, anyStatusUpdateData?.id]);

  useEffect(() => {
    if (open?.type === "EDIT" && manageLoading === false) {
      const eventType = open?.data?.type?.toLowerCase();

      form.setFieldsValue({
        event_type: eventType,
        status: singleCampaignData?.campaignStatus,
        id: anyStatusUpdateData?.id,
      });
    }
  }, [
    open?.data?.type,
    anyStatusUpdateData?.id,
    singleCampaignData?.campaignStatus,
    form,
    manageLoading,
    open?.type,
  ]);

  return (
    <FormModal
      disabled={false}
      open={open?.open}
      isUpdate={open?.type === "EDIT"}
      title="Status Update"
      onFinish={onFinish}
      handleClose={handleClose}
      buttonText="Update"
      showDraft={false}
      width={584}
      formProps={{
        form,
      }}
    >
      <Form.Item
        name="event_type"
        label="Event Type"
        rules={[
          {
            required: true,
            message: "Please select an event type",
          },
        ]}
      >
        <Radio.Group
          className="custom-radio  disabled-red"
          size="large"
          disabled
          value={open?.data?.type?.toLowerCase()}
        >
          {eventTypeData.map((el, idx) => (
            <Radio
              className="text-body text-base font-medium leading-7 mr-3.5"
              value={el}
              key={idx}
            >
              {el}
            </Radio>
          ))}
        </Radio.Group>
      </Form.Item>

      <Form.Item
        name="status"
        label="Status"
        rules={[
          {
            required: true,
            message: "Please select a status",
          },
        ]}
      >
        <Radio.Group className="custom-radio" size="large">
          {trainingMaterialStatus.map((el, idx) => (
            <Radio
              className="text-body text-base font-medium leading-7 mr-3.5"
              value={el}
              key={idx}
            >
              {el}
            </Radio>
          ))}
        </Radio.Group>
      </Form.Item>
    </FormModal>
  );
}
